
export const navigation = {
  methods: {
    buildRedirectionURL(reference) {
      const success_url = `/gracias/${reference}`;

      const failure_url = `/pago/${reference}`;
      return [success_url, failure_url];
    },
    navigateToThankYouPage(purchaseRef) {
      return this.$router.push({
        name: 'ThankYou',
        params: {
          reference: purchaseRef
        },
        query: {
          ...this.$route.query,
          wegow_direct: this.$route.query && this.$route.query.wegow_direct ? true : undefined
        }
      })
    },
    navigateToPaymentUrl(purchaseRef,buyer) {
      return this.$router.push({
        name: 'Payment',
        params: {
          reference: purchaseRef,
        },
        query: {
          buyer: buyer,
          ...this.$route.query,
          wegow_direct: this.$route.query && this.$route.query.wegow_direct ? true : undefined
        }
      })
    },
  }
}
